module.exports = __webpack_public_path__ + "static/img/tenderAnalyzeBg.c250f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/vipMember/img/tenderAnalyzeBg.png
// module id = Buzu
// module chunks = 23